module.exports = __webpack_public_path__ + "static/media/mobileban2.7befd69b.jpg";